import { formatBook } from "../../../utils/formatOdds";
/**
 * Bet table for Mogambo – reference admin markup (rendered inside .casino-detail of
 * .casino-table.mogambo.teenpatti2cards); styled by the ported reference rules in styles/index.css.
 */
const BetTableMogambo = ({
  data = [],
  onBetClick,
  exposures = {},
}) => {
  const getScore = (name) =>
    data.find((item) => item?.nat === name) || {
      b: 0,
      l: 0,
      bbhav: 0,
      lbhav: 0,
      min: 0,
      max: 0,
      gstatus: "",
    };

  const dagaTeja = getScore("Daga / Teja");
  const mogambo = getScore("Mogambo");
  const cardTotalItem = getScore("3 Card Total");

  /** Format min/max: thousands as K, lakhs as L (e.g. 100000 → 1L, 500000 → 5L) */
  const formatMinMax = (num) => {
    if (num == null || num === "") return "0";
    const n = Number(num);
    if (isNaN(n)) return String(num);
    if (n >= 100000) return `${n / 100000}L`;
    if (n >= 1000) return `${n / 1000}K`;
    return String(n);
  };

  // The page's book: Mogambo / Daga-Teja from the panel book, "3 Card Total" the worst
  // row of its line ladder (one figure for the market, as on the reference).
  const getExposure = (betType, nat) => {
    const exposureKeys = [
      nat,
      betType,
      nat?.toLowerCase?.()?.trim?.(),
      betType?.toLowerCase?.()?.trim?.(),
      nat?.replace?.(/\s+/g, " ")?.trim?.(),
    ];
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined) return exposures[key];
    }
    return 0;
  };

  // Reference: class "suspended" whenever gstatus != "OPEN"
  const isSuspended = (item) => !item || item?.gstatus !== "OPEN";

  /** Single back cell (Daga/Teja, Mogambo) – exposure shown in nation-name row only */
  const renderBackCell = (item, label) => {
    const value = item?.b ?? 0;
    const suspended = isSuspended(item);
    return (
      <div
        className={`back casino-bl-box-item${suspended ? " suspended" : ""}`}
        onClick={() => !suspended && onBetClick?.(value, label, "back", item)}
      >
        <span className="casino-box-odd">{value}</span>
      </div>
    );
  };

  /** 3 Card Total: lay and back cells (odd + bhav); exposure in row header */
  const renderTotalCell = (item, label, type) => {
    const isLay = type === "lay";
    const value = isLay ? (item?.l ?? 0) : (item?.b ?? 0);
    const smallVal = isLay ? (item?.lbhav ?? 0) : (item?.bbhav ?? 0);
    const suspended = isSuspended(item);
    return (
      <div
        className={`${isLay ? "lay" : "back"} casino-bl-box-item${suspended ? " suspended" : ""}`}
        onClick={() => !suspended && onBetClick?.(value, label, type, item)}
      >
        <span className="casino-box-odd">{value}</span> <span>{smallVal}</span>
      </div>
    );
  };

  // Reference v-casinobook: > 0 → book-green, otherwise book-red (0 shown as "0")
  const renderExposure = (exposure) => {
    const n = Number(exposure) || 0;
    return (
      <div className="float-right">
        <span className={`mr-2 ${n > 0 ? "book-green" : "book-red"}`}>{formatBook(n)}</span>
      </div>
    );
  };

  const minMax = (item, full) => (
    <div className={`text-right casino-min-max${full ? " w-100" : ""}`}>
      {"\n                      R:"}
      <span>{formatMinMax(item?.min)}</span>-<span>{formatMinMax(item?.max)}</span>
    </div>
  );

  // Reference markup (.casino-detail > .d-none-small): teen1daycasino-container (left/right) + three-card-total row
  return (
    <div className="d-none-small">
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>Daga / Teja</b> {renderExposure(getExposure("Daga / Teja", dagaTeja?.nat))}
            </div>{" "}
            <div className="casino-bl-box casino-bl-boxfull">{renderBackCell(dagaTeja, "Daga / Teja")}</div>
          </div>{" "}
          {minMax(dagaTeja)}
        </div>{" "}
        <div className="teen1dayright">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>Mogambo</b> {renderExposure(getExposure("Mogambo", mogambo?.nat))}
            </div>{" "}
            <div className="casino-bl-box casino-bl-boxfull">{renderBackCell(mogambo, "Mogambo")}</div>
          </div>{" "}
          {minMax(mogambo)}
        </div>
      </div>{" "}
      <div className="casino-box-row three-card-total">
        <div className="casino-nation-name">
          <b className="pointer">3 Card Total</b>{" "}
          {renderExposure(
            getExposure("3 Card Total", cardTotalItem?.nat)
          )}
        </div>{" "}
        <div className="casino-bl-box">
          {renderTotalCell(cardTotalItem, "3 Card Total", "lay")}{" "}
          {renderTotalCell(cardTotalItem, "3 Card Total", "back")}
        </div>{" "}
        {minMax(cardTotalItem, true)}
      </div>
    </div>
  );
};

export default BetTableMogambo;
